var _rect, _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgVisa(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 41,
    height: 28,
    viewBox: "0 0 41 28",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 0.835938,
    y: 0.5,
    width: 39,
    height: 27,
    rx: 2,
    fill: "white",
    stroke: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M12.555 18.9683H10.1318L8.31464 11.8914C8.22839 11.5659 8.04526 11.2781 7.77588 11.1425C7.10361 10.8016 6.36282 10.5303 5.55469 10.3935V10.121H9.45831C9.99707 10.121 10.4011 10.5303 10.4685 11.0056L11.4113 16.1104L13.8334 10.121H16.1892L12.555 18.9683ZM17.5361 18.9683H15.2476L17.132 10.121H19.4206L17.5361 18.9683ZM22.3814 12.572C22.4487 12.0955 22.8528 11.823 23.3242 11.823C24.065 11.7546 24.872 11.8914 25.5454 12.2311L25.9495 10.3263C25.276 10.0538 24.5352 9.91699 23.863 9.91699C21.6418 9.91699 20.0255 11.1425 20.0255 12.8433C20.0255 14.1372 21.1704 14.8165 21.9785 15.2258C22.8528 15.6339 23.1895 15.9064 23.1222 16.3145C23.1222 16.9266 22.4487 17.1991 21.7765 17.1991C20.9683 17.1991 20.1602 16.995 19.4206 16.6542L19.0165 18.5602C19.8247 18.8999 20.699 19.0367 21.5071 19.0367C23.9977 19.1039 25.5454 17.8796 25.5454 16.042C25.5454 13.7279 22.3814 13.5922 22.3814 12.572ZM33.5547 18.9683L31.7376 10.121H29.7858C29.3817 10.121 28.9776 10.3935 28.8429 10.8016L25.4781 18.9683H27.834L28.3042 17.6756H31.1988L31.4682 18.9683H33.5547ZM30.1225 12.5036L30.7947 15.838H28.9103L30.1225 12.5036Z",
    fill: "#172B85"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVisa);
export default __webpack_public_path__ + "static/media/visa.eddfa5457f9f82dfa705b130c6844bef.svg";
export { ForwardRef as ReactComponent };